<template>
    <div class="px-6 py-10">
        <!-- Header -->
        <div class="flex justify-between items-start p-4 mb-8">
            <h1 class="text-2xl font-medium text-gray-800">Pending Operations</h1>
            <div class="flex gap-x-4">
                <div class="text-right">
                    <div class="text-lg font-medium text-gray-600">{{ statusCounts.pending }} Operations</div>
                    <div class="text-sm text-primary">Pending Authorization</div>
                </div>
                <div class="text-right">
                    <div class="text-lg font-medium text-gray-600">{{ statusCounts.processing }} Operations</div>
                    <div class="text-sm text-primary">Processing</div>
                </div>
            </div>
        </div>

        <pending-operation @update-status="handleStatusUpdate"></pending-operation>
    </div>
</template>

<script setup>
import PendingOperation from "@/components/forYou/PendingOperation";
import { ref } from 'vue'


const statusCounts = ref({
  pending: 0,
  processing: 0
})

function handleStatusUpdate(data) {
  statusCounts.value.pending = data.pending
  statusCounts.value.processing = data.processing
}

</script>